module.exports = __webpack_public_path__ + "static/media/raychem-catalog-fi.4d8c38e9.pdf";